import React, { useState } from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import { ADDITIONAL_REQUIREMENTS } from './requirementData'
import { resolveUrlForArticles } from './utils/urlUtils'
import { interpolate, getCurrentUnixTimestamp } from './utils/displayUtils'
import { REQUIREMENT } from './utils/constants/levels'
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  AdditionalRequirementContent,
  AdditionalRequirementActions,
  AdditionalRequirementTextLink,
  TextButton,
  ActionButton,
  ActionButtonText
} from './Styles/ProgressTracker.styles'

const AdditionalRequirementsList = ({ additionalRequirements }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const hasPATRequirement = additionalRequirements.some(
    req => req.id === REQUIREMENT.PLAYING_ABILITY_TEST
  )
  const requirementsCount = hasPATRequirement ? 2 : 1
  
  const unixTimestamp = getCurrentUnixTimestamp()
  const patReq = ADDITIONAL_REQUIREMENTS.playing_ability_test
  const wecReq = ADDITIONAL_REQUIREMENTS.work_experience_credits

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {requirementsCount}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific level but must be completed before applying for PGA of America Membership.
          </AdditionalRequirementsDescription>

          {/* PAT Requirement - conditionally shown in list */}
          {hasPATRequirement && (
            <AdditionalRequirementCard>
              <AdditionalRequirementHeader>
                <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
                <AdditionalRequirementTitle>
                  {patReq.name}
                </AdditionalRequirementTitle>
              </AdditionalRequirementHeader>
              <AdditionalRequirementContent>
                <AdditionalRequirementDescription>
                  {patReq.message}
                </AdditionalRequirementDescription>
                <AdditionalRequirementActions>
                  <ActionButton 
                    as="a" 
                    href={interpolate(patReq.primaryLinkUrl, { unixTimestamp })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ActionButtonText>{patReq.primaryLinkText}</ActionButtonText>
                  </ActionButton>
                  <AdditionalRequirementTextLink 
                    as="a" 
                    href={resolveUrlForArticles(patReq.secondaryLinkUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {patReq.secondaryLinkText}
                  </AdditionalRequirementTextLink>
                </AdditionalRequirementActions>
              </AdditionalRequirementContent>
            </AdditionalRequirementCard>
          )}

          {/* Work Experience Credits - always shown in list */}
          <AdditionalRequirementCard>
            <AdditionalRequirementHeader>
              <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
              <AdditionalRequirementTitle>
                {wecReq.name}
              </AdditionalRequirementTitle>
            </AdditionalRequirementHeader>
            <AdditionalRequirementDescription>
              {wecReq.message}{' '}
              <TextButton 
                as="a" 
                href={resolveUrlForArticles(wecReq.linkUrl)} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {wecReq.linkText}
              </TextButton>
            </AdditionalRequirementDescription>
          </AdditionalRequirementCard>
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
